import React, { Component } from 'react';
import Aux from '../../../hoc/Aux';
import axios from '../../../axios-ns';
import classes from './MyTrainings';
import { Link } from 'react-router-dom'
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import * as messages from '../../../messages';
import Spinner from '../../../components/UI/Spinner/Spinner';
import ChatIcon from '@material-ui/icons/Chat';
import AudioTrackIcon from '@material-ui/icons/Audiotrack';

class MyTrainings extends Component {
    state = {
        trainings: [],
        loading: true
    }

    componentDidMount() {
        if (localStorage.getItem('token')) {
            axios.get('protected/products/my', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then(response => {
                    this.setState({ trainings: response.data, loading: false });
                }).catch(err => {
                    this.setState({ ...this.state, loading: false });

                })
        }
    }

    render() {
        let content = <p>Nie posiadasz jeszcze żadnych usług.</p>;
        let startButton = null;

        if (this.state.loading) {
            content = <Spinner />
        } else if (this.state.trainings && this.state.trainings.length > 0) {
            content = this.state.trainings.map(t => {
                let upgradeButton = null;

                if (t.status === 'PENDING_PAYMENT') {
                    startButton = <p style={{ color: '#f50057' }}>{messages.PENDING_PAYMENT}</p>
                } else {
                    let path = t.type === 'CHECK_SONG' ? '/protected/check-song/' : 
                    (t.personalized === '1' ? '/protected/product-workouts/' : '/protected/training/'); //Spersonalizowany trening
                    startButton = t.evaluationStatus == 'WAITING_FOR_EVALUATION' ? <b>Oczekiwanie na raport</b> : <Button variant="contained" color="primary" type="button" component={Link} to={path + t.transactionCode} style={{ marginLeft: '10px', marginRight: '10px', backgroundColor: 'orange' }}>
                        {t.evaluationStatus == 'EVALUATED' ? messages.SEE_REPORT : messages.START_TRAINING}
                    </Button>
                }

                if (t.upgradesAvailable == true && t.status != 'PENDING_PAYMENT') {
                    upgradeButton = <Button color="primary" style={{backgroundColor: '#fff'}} component={Link} to={'/protected/training/' + t.productCode + '/upgrades'}>
                        {messages.SHOW_UPGRADES}
                    </Button>
                }


                let workProgress = t.numberOfWorkouts > 0 ? Math.ceil(t.numberOfCompletedWorkouts * 100 / t.numberOfWorkouts) : null;
                let color = null;
                let padding = '6px 3px';
                let fontSize = '15px';

                if(workProgress < 10) {
                    padding = '6px 6px';
                    color = '#3fe4ba';                
                } else if(workProgress <= 20) {
                    color = '#3fe43f';
                } else if(workProgress <= 30) {
                    color = '#68e43f';
                } else if(workProgress <= 40) {
                    color = '#91e43f';
                } else if(workProgress <= 50) {
                    color = '#bae43f';
                } else if(workProgress <= 60) {
                    color = '#e4e43f';
                } else if(workProgress <= 70) {
                    color = '#e4ba3f';
                } else if(workProgress <= 80) {
                    color = '#e4913f';
                } else if(workProgress <= 90) {
                    color = 'orange';
                } else if(workProgress < 100) {
                    color = '#e4683f';
                } else {
                    padding = '10px 3px';
                    color = '#e4683f';
                    fontSize = '14px';
                }

                let workoutProgress = t.numberOfWorkouts > 0 ? <span style={{padding: padding, color: color, border: '1px solid', borderColor: color, borderRadius: '20px', fontWeight: 'normal', marginTop: '-10px', fontSize: fontSize, marginLeft: '10px'}}>{workProgress}%</span> : null;
                let newMessage = t.unreadMessages > 0  ? <span style={{ color: 'orange' }} title="Nowe, nieprzeczytane wiadomości"><ChatIcon /> {t.unreadMessages}</span> : <span style={{ color: '#ddd' }} title="Brak nowych wiadomości"><ChatIcon /> 0 </span>;
                let newSampleResponse = t.unreadSampleEvaluations > 0 || t.evaluationStatus == 'EVALUATED' ? <span style={{ color: 'orange' }} title="Nowa ocena Twoich nagrań"><AudioTrackIcon /> {t.evaluationStatus == 'EVALUATED' ? '1' : t.unreadSampleEvaluations}</span> : <span style={{ color: '#ddd' }} title="Brak nowych ocen nagrań"><AudioTrackIcon style={{ color: '#ddd' }} /> 0 </span>;
                let controls = (<Aux><div style={{ marginTop: '18px' }}>{newMessage}{newSampleResponse}{workoutProgress}</div></Aux>);

                return <Card key={t.name} className={classes.card} style={{ marginBottom: '10px' }}>
                    <CardHeader
                        avatar={
                            <Avatar aria-label="Recipe" className={classes.avatar} style={{ backgroundColor: t.color }}>
                                {t.productCode}
                            </Avatar>
                        }
                        action={controls}
                        title={t.name}
                    />
                    <CardActionArea>
                        <CardMedia
                            component="img"
                            style={{ border: '0px', padding: '0px', borderRadius: '0px', borderTop: '1px solid #eee', borderBottom: '1px solid #eee' }}
                            image={t.thumbnail}
                            title=""
                        />
                    </CardActionArea>
                    <CardActions style={{ float: 'right' }}>
                        {upgradeButton}
                        {startButton}
                    </CardActions>
                </Card>
            }
            );
        } else {
            content = (<Card style={{ padding: '10px' }}>
                <p>Ooooł! Trochę tu pusto. Przejdź do listy polecanych usług, a z pewnością znajdziesz tam coś interesującego dla siebie.
                <img src="https://nauka-spiewu.pl/assets/images/pw/pw_046.JPG" style={{ width: '100%', maxWwidth: '500px', float: 'center', marginTop: '20px', marginBottom: '20px' }} />
                </p>
                <p style={{textAlign: 'center'}}>
                    <Button style={{display: 'inline-block'}} variant="contained" size="small" color="primary" component={Link} to={'/protected/products'}>
                        {messages.RECOMMENDED_PRODUCTS}
                    </Button>
                </p>
            </Card>);
        }

        return <Aux>
            {content}
        </Aux>;
    }
}


export default MyTrainings; 